import React, { forwardRef } from 'react';
import DocumentCard from 'Components/Documents/DocumentCard';
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { ERROR_MESSAGES } from 'Utils/constants';
import { useDispatch } from 'react-redux';

export const DocumentTemplateContent = forwardRef((data, ref) => {
  const dispatch = useDispatch();
  const commonFormatsData = data.data.commonFormatsData;
  const levelHeadingClasses = data.levelHeadingClasses;

  const errorHandle = () => {
    setGlobalErrorStatus({
      dispatch,
      popupData: {
        visible: true,
        title: ERROR_MESSAGES.GENERAL_ERROR.title,
        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
        showContactHelp: true,
      },
      redirect: { redirect: false, redirectFirst: false, path: '', data: {} },
    });
  };

  const renderCards = (cardsArr) => {
    if (!cardsArr || cardsArr.length === 0) return null;
    return (
      <div className="cf-doc-card-container g-3 mt-2">
        {cardsArr.map((groupId, idx) => (
          <div key={`cf-doc-card-${groupId}-${idx}`} className="d-flex">
            <DocumentCard groupId={groupId} errorHandle={errorHandle} />
          </div>
        ))}
      </div>
    );
  };

  const renderContent = (item, index, level, parentKey = '', lastLevel1Item) => {
    const key = `${parentKey}level${level}-${index}`;

    if (level === 1 && !item.title && item.children) {
      return (
        <React.Fragment key={key}>
          {item.children.map((child, childIndex) =>
            renderContent(child, childIndex, 2, key + '-', lastLevel1Item)
          )}
          {index !== lastLevel1Item - 1 ? <div className="mt-5 mb-5 common-formats-border-bottom-dashed" /> : null}
        </React.Fragment>
      );
    }

    return (
      <div key={key}>
        <div ref={(el) => (ref.current[key] = el)} className="mb-5">
          {item.title && (
            level === 1
              ? <h2 className={`mb-3 common-formats-header ${levelHeadingClasses?.[1] ?? 'displayM bold color-primary-navyblue'}`} id={item.id}>{item.mainContentTitle ?? item.title}</h2>
              : level === 2
                ? <h3 className={`mb-3 common-formats-header ${levelHeadingClasses?.[2] ?? 'displayS bold color-primary-navyblue'}`} id={item.id}>{item.mainContentTitle ?? item.title}</h3>
                : <h4 className={`mb-3 common-formats-header ${levelHeadingClasses?.[3] ?? 'displayXS bold color-primary-navyblue'}`} id={item.id}>{item.mainContentTitle ?? item.title}</h4>
          )}
          {item.content && <div className="mt-3 mb-3 body common-formats-main-content-text">{item.content}</div>}
          {item.cardsPrologue && <div className="mt-1 mb-3 body">{item.cardsPrologue}</div>}
          {renderCards(item.cards)}
        </div>

        {item.children && item.children.map((child, childIndex) =>
          renderContent(child, childIndex, level + 1, key + '-', lastLevel1Item)
        )}

        {level === 1 && index !== lastLevel1Item - 1 && item.title
          ? <div className="mt-5 mb-5 common-formats-border-bottom-dashed" />
          : null}
      </div>
    );
  };

  return (
    <div className="common-formats-main-content">
      {commonFormatsData.map((item, index) =>
        renderContent(item, index, 1, '', commonFormatsData.length)
      )}
    </div>
  );
});
